import React from "react";
import { Alert, Button } from "reactstrap";

/**
 * Won / Lost disposition bar. Shown only when:
 *   - the CR is in Ready state, AND
 *   - QuoteNumber > 0 (quote-driven CR), AND
 *   - the caller is the author (canWonLost).
 * Mirrors the TableLayoutPanel3 region in the legacy form (Pass 1 §1.4) and the
 * UpdateWonLost call inside FormClosing (Pass 1 §1.10).
 */
export default function WonLostBar({ won, lost, onChange, onSubmit, disabled }) {
    const ready = won === true || lost === true;
    return (
        <Alert color="warning" className="d-flex align-items-center gap-3 flex-wrap">
            <div className="w-100 fw-semibold">
                <i className="ri-flag-line me-1" />
                Final step — this is a quote. Mark it Won or Lost to approve and archive the contract review.
            </div>
            <strong>Quote Disposition:</strong>
            <label className="form-check d-flex align-items-center gap-1 mb-0">
                <input
                    type="radio"
                    className="form-check-input"
                    checked={won === true}
                    onChange={() => onChange(true, false)}
                    disabled={disabled}
                />
                <span>Won</span>
            </label>
            <label className="form-check d-flex align-items-center gap-1 mb-0">
                <input
                    type="radio"
                    className="form-check-input"
                    checked={lost === true}
                    onChange={() => onChange(false, true)}
                    disabled={disabled}
                />
                <span>Lost</span>
            </label>
            <Button color="success" size="sm" onClick={onSubmit} disabled={disabled || !ready}
                title={!ready ? "Choose Won or Lost first" : "Save the disposition, approve and archive this CR"}>
                <i className="ri-check-double-line me-1" />
                Approve &amp; Archive (Final)
            </Button>
        </Alert>
    );
}
